import { createSlice } from "@reduxjs/toolkit";
import { createInquirySource, editInquirySource, getAllInquirySources } from "../../builders/inquirySource/inquirySource.builder";

const initialState = {
    inquirySourceData: [],
    loading : false,
};

const inquirySource = createSlice({
    name: "inquirySource",
    initialState,
    reducers: {

        clearExtraReducers: (state) => {
            state.inquirySourceData = []
            state.loading = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllInquirySources.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getAllInquirySources.fulfilled, (state, action) => {
            state.loading = false
            state.inquirySourceData = action.payload
        });
        builder.addCase(getAllInquirySources.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(createInquirySource.pending, (state) => {
            state.loading = true
        });
        builder.addCase(createInquirySource.fulfilled, (state) => {
            state.loading = false
        });
        builder.addCase(createInquirySource.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(editInquirySource.pending, (state) => {
            state.loading = true
        });
        builder.addCase(editInquirySource.fulfilled, (state) => {
            state.loading = false
        });
        builder.addCase(editInquirySource.rejected, (state) => {
            state.loading = false
        });


    },
});

// export const { } = followupSlice.actions;

export default inquirySource.reducer;
